/* eslint-disable jsx-a11y/iframe-has-title */
import { teal } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import { useRouter } from 'next/router';
import React from 'react';
import AboutSelect from '../../components/About/AboutSelect';
import ContactForm from '../../components/About/ContactForm';
import Footer from '../../components/General/Footer';
import HeaderCard from '../../components/General/HeaderCard';
import Head from '../../components/Header/Head';
import Header from '../../components/Header/Header';
import withApollo from '../../lib/withApollo';
import ChatWithUsDiscordButton from '../../components/About/ChatWithUsDiscordButton';
import Typography from '@mui/material/Typography';

const ContactPage = () => {
  const router = useRouter();

  let messagePlaceholder = 'Type your message here';
  let subject;
  if (router.query) {
    const {
      content,
      advertising,
      press,
      investors,
      support,
      integration,
      community,
      domain,
      accountdeletion,
    } = router.query;
    if (content) {
      subject = 'Content';
      messagePlaceholder =
        'Please provide details about your removal request here. If you want to report a post, you can also report posts to our content team by using the report function in the three-dot-menu at the top-right of a post.';
    } else if (accountdeletion) {
      subject = 'Account Deletion';
      messagePlaceholder =
        'Please specify if you would like to delete your account permanetly and irreversibly or deactivate your account.';
    } else if (advertising) {
      subject = 'Advertising';
      messagePlaceholder = 'Type your message here';
    } else if (press) {
      subject = 'Press';
      messagePlaceholder = 'Type your message here';
    } else if (integration) {
      subject = 'Integration Request';
      messagePlaceholder =
        'Please let us know details about the integration you would like to request';
    } else if (community) {
      subject = 'Create a community';
      messagePlaceholder =
        'Community integration is currently manual. Please let us know details about the community you would like to create. This can either be a new community or an existing Hive community.';
    } else if (investors) {
      subject = 'Investment';
      messagePlaceholder = 'Type your message here';
    } else if (support) {
      subject = 'Support';
      messagePlaceholder =
        'What can we help you with? You can also contact us on our Discord server for chat support';
    } else if (domain) {
      subject = 'Connect Domain to Blog';
      messagePlaceholder =
        'Please let us know the domain you would like to connect to your blog. We will get back to you as soon as possible.';
    } else {
      subject = '';
      messagePlaceholder = 'Type your message here';
    }
  }

  const title = 'Contact Us';
  return (
    <>
      <Header subheader={title} />
      <Head
        title={`${title}`}
        description="Get in touch with the TravelFeed team that made travel blogging accessible for everyone"
      />
      <AboutSelect selection={4} />
      <Grid
        container
        spacing={0}
        alignItems="center"
        justifyContent="center"
        className="pt-4 pb-4"
      >
        <Grid item lg={7} md={8} sm={11} xs={12}>
          <HeaderCard
            title={title}
            background={teal[600]}
            content={
              <>
                <div className="container">
                  <ContactForm
                    subject={subject}
                    messagePlaceholder={messagePlaceholder}
                  />
                  <Typography gutterBottom variant="h5" className="pt-4">
                    Or reach out on Discord
                  </Typography>
                  <ChatWithUsDiscordButton isOutlined />
                </div>
              </>
            }
          />
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default withApollo(ContactPage);
